import Slide from '@mui/material/Slide';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import GameMultiplier from '../Multiplier';
import { RouletteEndBannerProps } from './props';
import styles from './styles.module.scss';

function RouletteEndBanner({
  multiplier,
  isClosed = true,
}: RouletteEndBannerProps) {
  const { t } = useTranslation('roulette');

  return (
    <Slide in={true} timeout={500}>
      <div className={styles.container}>
        <span className={styles.container__text}>
          <GameMultiplier
            isClosed={isClosed}
            multiplier={multiplier}
            text={t('betblex_multiply', {
              profit: '',
              platform: '',
            })}
            rowVariant
          />
        </span>
      </div>
    </Slide>
  );
}

export default memo(RouletteEndBanner);
